import { FC } from 'react';

import { Loader } from '@gem/ui-kit';

import styles from './Landing.styles.m.css';

export const Loading: FC = () => {
  return (
    <div className={styles.container}>
      <Loader
        color="brand-primary"
        size="big"
      />
    </div>
  );
};
